import { useState, useEffect } from "react";
import { Pencil } from "lucide-react";
import { useNavigate } from "react-router-dom";
import TopNavBar from "../components/TopNavBar";

export default function AdminPage() {
  const [title, setTitle] = useState(localStorage.getItem("title"));
  const [healthplan_name, setHealthplan_name] = useState("Aetna ");
  const [firstName, setFirstName] = useState("Robert");
  const [lastName, setLastName] = useState("Jones");
  const [dob, setDob] = useState("06/01/1958");
  const [benefit_plan, setbenefit_plan] = useState("HMO PPO");
  const [doctorName, setDoctorName] = useState("Dr. Williamson");
  const [isEditing, setIsEditing] = useState(false);
  const [showAlert, setShowAlert] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const isAuth = localStorage.getItem('isAuthenticated') === 'true';
    if (!isAuth) {
      navigate('/login');
    }
  }, [navigate]);

  useEffect(() => {
    // Load all values from localStorage - using the same keys as in handleSaveAndExit
    const organization_name = localStorage.getItem("organization_name");  // Changed from "title"
    const healthplan_name = localStorage.getItem("healthplan_name");
    const stored_firstName = localStorage.getItem("first_name");
    const stored_lastName = localStorage.getItem("last_name");
    const stored_dob = localStorage.getItem("date_of_birth");
    const stored_benefit_plan = localStorage.getItem("benefit_plan");    // Set the state with localStorage values if they exist
    const stored_doctorName = localStorage.getItem("doctor_name");
    if (organization_name) setTitle(organization_name);
    if (healthplan_name) setHealthplan_name(healthplan_name);
    if (stored_firstName) setFirstName(stored_firstName);
    if (stored_lastName) setLastName(stored_lastName);
    if (stored_dob) setDob(stored_dob);
    if (stored_benefit_plan) setbenefit_plan(stored_benefit_plan);
    if (stored_doctorName) setDoctorName(stored_doctorName);
  }, []); // Empty dependency array means this runs once when component mounts

  const handleSaveAndExit = () => {
    // Save all values to localStorage
    localStorage.setItem("organization_name", title || "");
    localStorage.setItem("healthplan_name", healthplan_name);
    localStorage.setItem("first_name", firstName);
    localStorage.setItem("last_name", lastName);
    localStorage.setItem("date_of_birth", dob);
    localStorage.setItem("benefit_plan", benefit_plan);
    localStorage.setItem("doctor_name", doctorName);
    
    setIsEditing(false);
    setShowAlert(true);
    setTimeout(() => setShowAlert(false), 3000);
    navigate("/home");
  };

  const handleCancel = () => {
    navigate('/home'); // This will navigate to home page
  };

  const formatDate = (input: string) => {
    // Remove any non-digit characters
    const numbers = input.replace(/\D/g, '');
    
    // Add slashes after MM and DD
    if (numbers.length <= 2) return numbers;
    if (numbers.length <= 4) return `${numbers.slice(0, 2)}/${numbers.slice(2)}`;
    return `${numbers.slice(0, 2)}/${numbers.slice(2, 4)}/${numbers.slice(4, 8)}`;
  };

  const handleDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const formatted = formatDate(e.target.value);
    if (formatted.length <= 10) {  // Limit to MM/DD/YYYY format
      setDob(formatted);
    }
  };

  return (
    <div className="bg-gray-50 min-h-screen flex flex-col overflow-hidden font-inter">
      <div>
        <TopNavBar />
      </div>
    <div className="mt-30px bg-gray-50 min-h-screen flex flex-col justify-center items-center">

      <div className="max-w-md w-full p-6 bg-white rounded-2xl shadow-md mt-[-50px]">
        <h2 className="text-xl font-medium mb-4 text-gray-800 font-inter">Galileo Admin Console</h2>
        
        <div className="space-y-3">
        <div>
            <label className="block text-xxl text-gray-600 mb-1 font-inter"> Platform Header</label>
            <input 
              type="text" 
              value={title || ""} 
              onChange={(e) => setTitle(e.target.value)} 
              placeholder="Enter Organisation Name"
              className="w-full py-2 px-3 bg-gray-100 border border-gray-300 rounded-lg focus:ring focus:ring-blue-200 focus:outline-none font-inter"
            />
          </div>
          <div>
            <label className="block text-xxl text-gray-600 mb-1 font-inter">Health Plan Name</label>
            <input 
              type="text" 
              value={healthplan_name} 
              onChange={(e) => setHealthplan_name(e.target.value)} 
              placeholder="Enter Health Name"
              className="w-full py-2 px-3 bg-gray-100 border border-gray-300 rounded-lg focus:ring focus:ring-blue-200 focus:outline-none font-inter"
            />
          </div>

          <div>
            <label className="block text-xxl text-gray-600 mb-1 font-inter">First Name</label>
            <input 
              type="text" 
              value={firstName} 
              onChange={(e) => setFirstName(e.target.value)} 
              placeholder="Enter First Name"
              className="w-full py-2 px-3 bg-gray-100 border border-gray-300 rounded-lg focus:ring focus:ring-blue-200 focus:outline-none font-inter"
            />
          </div>

          <div>
            <label className="block text-xxl text-gray-600 mb-1 font-inter">Last Name</label>
            <input 
              type="text" 
              value={lastName} 
              onChange={(e) => setLastName(e.target.value)} 
              placeholder="Enter Last Name"
              className="w-full py-2 px-3 bg-gray-100 border border-gray-300 rounded-lg focus:ring focus:ring-blue-200 focus:outline-none font-inter"
            />
          </div>

          <div>
            <label className="block text-xxl text-gray-600 mb-1 font-inter">Birth Date</label>
            <input 
              type="text" 
              value={dob} 
              onChange={handleDateChange} 
              placeholder="MM/DD/YYYY"
              maxLength={10}
              className="w-full py-2 px-3 bg-gray-100 border border-gray-300 rounded-lg focus:ring focus:ring-blue-200 focus:outline-none font-inter"
            />
          </div>

          <div>
            <label className="block text-xxl text-gray-600 mb-1 font-inter">Benefit Plan Name</label>
            <input 
              type="text" 
              value={benefit_plan} 
              onChange={(e) => setbenefit_plan(e.target.value)} 
              placeholder="Enter Benefit Plan Name"
              className="w-full py-2 px-3 bg-gray-100 border border-gray-300 rounded-lg focus:ring focus:ring-blue-200 focus:outline-none font-inter"
            />
          </div>
          {/* <div>
            <label className="block text-xxl text-gray-600 mb-1 font-inter">Doctor Name</label>
            <input 
              type="text" 
              value={doctorName} 
              onChange={(e) => setDoctorName(e.target.value)} 
              placeholder="Enter Doctor Name"
              className="w-full py-2 px-3 bg-gray-100 border border-gray-300 rounded-lg focus:ring focus:ring-blue-200 focus:outline-none font-inter"
            />
          </div> */}
        </div>

        <div className="mt-6 flex justify-end gap-4">
          <button
            className="w-32 py-2 bg-gray-100 text-gray-600 rounded-lg font-medium hover:bg-gray-200 transition-colors font-inter"
            onClick={handleCancel}
          >
            Cancel
          </button>
          
          <button
            className="w-32 py-2 bg-blue-500 hover:bg-blue-600 text-white rounded-lg font-medium transition-colors font-inter"
            onClick={handleSaveAndExit}
          >
            Save & Exit
          </button>
        </div>
      </div>
    </div>
    </div>
  );

}
